import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";

import apiClient from "../../lib/common/apiClient";
import getNewDateObj from "../../lib/common/getNewDateObj";
import { getFormatDate } from "../../lib/common/dateFormat";

import DeleteRecordButtonLayout from "../layout/DeleteRecordButtonLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";
import failureKey from "../../lib/common/failureKey";


function DeleteRecordButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, makeItemName, onSuccess, onFailure, onPartialFailure, modifyUrlCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();
    const [deleteReason, setDeleteReason] = useState("");
    const [hasDeleteReason, setHasDeleteReason] = useState(false);

    useEffect((() => {
        setHasDeleteReason(schema && schema.columns.some(column => column.name === "apiHistoryReason"));
    }), [schema]);

    const makeReasonStr = ( reasons ) => {

        let reasonStr = " [";

        for ( const index in reasons ) {

            if ( index > 0 ) {

                reasonStr += ", ";

            }

            reasonStr += reasons[index];

        }

        reasonStr += "]";

        return reasonStr;

    };

    const onOpen = () => {
        let deleteData = [];
        let deleteItemStr = "[";

        let firstRow = true;

        for ( const item of grid.selectedItems ) {

            if ( !firstRow ) {

                deleteItemStr += ", ";

            }

            if ( makeItemName ) {

                deleteItemStr += makeItemName( item );

            } else {

                let itemDetail = "{";

                let firstCol = true;
    
                for ( let key of schema.keys ) {
    
                    if ( ! firstCol ) {
    
                        itemDetail += ", ";
    
                    }
    
                    // 날짜 키는 시각을 떼고 목록(dateSimple)과 같은 날짜만 보인다 — 목록이 뷰라 테이블 스키마에 grid 가 없으면 날짜 칸(formItemType)으로 본다
                    const keyColumn = schema.columns?.find ( ( column ) => column.name === key );
                    const isDate = keyColumn?.grid?.type === "dateSimple" || keyColumn?.formItemType === "date";

                    itemDetail += ( t(`columnName.${key}`) + ": " + ( isDate && item[key] ? getFormatDate ( getNewDateObj ( item[key] ) ) : item[key] ) );
    
                    firstCol = false;
    
                }
    
                itemDetail += "}";
    
                deleteItemStr += itemDetail;
    
            }

            firstRow = false;

            deleteData.push ( {...item} );

        }

        deleteItemStr += "]"
        
        setConfirmMsg ( t( "dialog.msg.confirm.delete", { type: t(`tableName.${schema.name}`), instance: deleteItemStr } ) );
        setConfirmData ( deleteData );

        setDeleteReason("");
        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onDeleteOk = ( requestData ) => {
        let dataWithReason = Array.isArray(requestData) && deleteReason
            ? requestData.map(item => ({ ...item, apiHistoryReason: deleteReason }))
            : requestData;

        let url = "/api/" + schema.name;

        if (modifyUrlCallback) {

            url = modifyUrlCallback(url);

        }

        apiClient.bulkDel ( url, dataWithReason )
            .then ( ( result ) => {

                if ( result.data.fails.length === 0 ) {

                    if(refresh) {
                        refresh.refresh();
                    }

                    onSuccess ( t ( "success.deleteSuccess", { table: schema.name, deleteCount: result.data.successes.length.toString() } ) );

                } else if ( result.data.successes.length === 0 ) {

                    let reasons = makeReasonStr ( result.data.reasons );
                    onFailure ( t ( failureKey ( "delete", result.data.statuses ), { reason: reasons } ))

                } else {

                    let reasons = makeReasonStr ( result.data.reasons );

                    if(refresh) {
                        refresh.refresh();
                    }

                    onPartialFailure ( t ( "warning.partialDeleteFailure", { success: result.data.successes.length, fail: result.data.fails.length, reason: reasons } ) )
                }

            })
            .catch ( ( reason ) => {

                console.error ( reason );                
                onFailure ( t ( failureKey ( "delete", reason.response?.status ), { reason: reason.response ? reason.response.data : reason } ))

            });

    }

    return (
        <>
            {/* 스키마가 오기 전에 누르면 확인 문구를 만들지 못해 TypeError 가 난다 — 그동안 끈다 */}
            <DeleteRecordButtonLayout id={id+"delete-button"} onClick={onOpen} {...others} disabled={!schema || others.disabled} />
            <ConfirmDialog
                id={id+"-delete-confirm-dialog"}
                title={ schema ? t ( `dialog.title.${schema.name}.delete` ) : "" }
                msg={
                    <>
                        <div>{confirmMsg}</div>
                        {hasDeleteReason &&<TextField
                            label={t("columnName.apiHistoryReason") || "사유"}
                            value={deleteReason}
                            onChange={e => setDeleteReason(e.target.value)}
                            fullWidth
                            required
                            margin="normal"
                        />}
                    </>
                }
                data={confirmData}
                open={open}
                // 필수로 표시한 사유 칸을 비우면 삭제하지 못한다
                okDisabled={hasDeleteReason && !deleteReason.trim()}
                onClose={onClose}
                onOk={onDeleteOk}
                onCancel={onClose}
            />
        </>
    );

}

export default DeleteRecordButton;

